import React from "react";
import { Link } from "react-router-dom";

const MarketingHeader = () => {

    return (

        <div className="marketing-header">

            <div>

                <h2>Marketing Campaigns</h2>

                <p>

                    Manage banners, offers and promotional campaigns.

                </p>

            </div>

            <Link
                to="/admin/marketing/create"
                className="create-btn"
            >

                + Create Campaign

            </Link>

        </div>

    );

};

export default MarketingHeader;